import { render, staticRenderFns } from "./MemberFundsInfo.vue?vue&type=template&id=4f7f12c6&scoped=true"
import script from "./MemberFundsInfo.vue?vue&type=script&lang=js"
export * from "./MemberFundsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7f12c6",
  null
  
)

export default component.exports